import WordFilteringUtil from '../libraries/mfc/MfcACRText'

const parser = new WordFilteringUtil()

export const getBannedWords = () =>
    Object.keys(parser.word_filter.banned_string)
export const getBannedNouns = () => Object.keys(parser.word_filter.nouns)
export const getBannedAdjectives = () =>
    Object.keys(parser.word_filter.adjectives)
export const getBannedVerbs = () => Object.keys(parser.word_filter.verbs)

export function filterAndReplaceBadWords(
    content: string,
    replaceWith?: string,
) {
    return parser.process(
        content,
        replaceWith
            ? {
                  replace_vowels: true,
                  replacement_char: replaceWith,
              }
            : {},
    )
}

export function containsBadWord(content: string) {
    return parser.banned_words(content)
}

// an age-gated region filters words as the rest of the app does: names lose their vowels, text is filtered, banned tags are dropped
export const ageGateWordFilter = (active: boolean) => ({
    name: (value: string): string =>
        active && value ? filterAndReplaceBadWords(value, 'x') : value,
    text: (value: string): string =>
        active && value ? filterAndReplaceBadWords(value) : value,
    allowsTag: (tag: string) => !active || !containsBadWord(tag),
})
